import { render, staticRenderFns } from "./FormGeneric.vue?vue&type=template&id=2bcf79ea&"
import script from "./FormGeneric.vue?vue&type=script&lang=js&"
export * from "./FormGeneric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports